import { API_BASE_URL, getAuthHeaders } from "../API/Api";
import { getPaginationInfo } from "../Brands/brandUtils";

export const slugify = (value) =>
  String(value || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");

export const generateProductSlug = (name, sku = "") => {
  const base = slugify(name) || "product";
  if (String(sku || "").trim()) {
    return `${base}-${slugify(sku)}`;
  }
  return `${base}-${Date.now()}`;
};

export const getProductApiErrorMessage = (errorData, fallback) => {
  if (errorData?.message) return errorData.message;
  const errors = errorData?.errors;
  if (errors && typeof errors === "object") {
    const firstKey = Object.keys(errors)[0];
    if (firstKey && Array.isArray(errors[firstKey])) {
      return errors[firstKey][0];
    }
  }
  return fallback;
};

export const buildProductPayload = (formData) => ({
  name: formData.name.trim(),
  slug: formData.slug || generateProductSlug(formData.name, formData.sku),
  sku: formData.sku.trim() || null,
  code: formData.code.trim() || null,
  ingredients: formData.ingredients.trim() || null,
  price:
    formData.price === "" || formData.price == null ? null : formData.price,
  case_size: formData.case_size || null,
  layer: formData.layer ? Number(formData.layer) : null,
  pallet: formData.pallet ? Number(formData.pallet) : null,
  unit_barcode: formData.unit_barcode || null,
  case_barcode: formData.case_barcode || null,
  net_weight: formData.net_weight || null,
  vat: formData.vat || null,
  case_length: formData.case_length || null,
  case_width: formData.case_width || null,
  case_height: formData.case_height || null,
  gross_weight: formData.gross_weight || null,
  units_per_case: formData.units_per_case
    ? Number(formData.units_per_case)
    : null,
  tariff: formData.tariff || null,
  origin: formData.origin || null,
  image: formData.image || null,
  brand_id: formData.brand_id ? Number(formData.brand_id) : null,
  category_id: formData.category_id ? Number(formData.category_id) : null,
  filter_ids: (formData.filter_ids || []).map((id) => Number(id)),
  is_active: formData.is_active,
});

export const fetchAllProducts = async () => {
  const allProducts = [];
  let page = 1;
  let lastPage = 1;

  do {
    const res = await fetch(
      `${API_BASE_URL}/admin/products?per_page=3000&page=${page}`,
      {
        headers: getAuthHeaders(),
      },
    );

    if (!res.ok) {
      throw new Error(`HTTP error! Status: ${res.status}`);
    }

    const responseData = await res.json();
    const { items, lastPage: totalPages } = getPaginationInfo(responseData);
    allProducts.push(...items);
    lastPage = totalPages;
    page += 1;
  } while (page <= lastPage);

  return allProducts;
};

export const normalizeProductRow = (item, index) => ({
  index: index + 1,
  id: item.id,
  name: item.name || "",
  slug: item.slug || "",
  price: item.price || "",
  image_url:
    item.image_url ||
    item?.images?.[0]?.image_url ||
    item?.images?.[0]?.url ||
    "",
  brand_name: item?.brand?.name || "",
  category_name: item?.category?.name || "",
  is_active: !!item?.is_active,
});
